module.exports = __webpack_public_path__ + "static/media/teenpatti20.946a1b3a.webp";